/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DemandsInputs */

const cs_nav_demands = /** @type {(inputs: Nav_DemandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávky`)
};

const en_nav_demands = /** @type {(inputs: Nav_DemandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requests`)
};

/**
* | output |
* | --- |
* | "Requests" |
*
* @param {Nav_DemandsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_demands = /** @type {((inputs?: Nav_DemandsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DemandsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_demands(inputs)
	return cs_nav_demands(inputs)
});